export function extractLocations(responses) {
  const grouped = {}

  responses.forEach((response) => {
    const geo =
      response.geolocation ||
      response.metadata?.geolocation ||
      response.client_info?.geolocation ||
      response.meta?.geolocation
    if (!geo) return

    const lat = geo.latitude ?? geo.lat
    const lng = geo.longitude ?? geo.lng ?? geo.lon
    if (lat == null || lng == null) return

    const name =
      [geo.city, geo.region, geo.country || geo.country_name].filter(Boolean).join(', ') ||
      'Unknown'
    const key = `${name}__${Number(lat).toFixed(2)}_${Number(lng).toFixed(2)}`

    if (!grouped[key]) {
      grouped[key] = { name, lat: Number(lat), lng: Number(lng), count: 0 }
    }
    grouped[key].count += 1
  })

  return Object.values(grouped)
}

export function buildPopupContent(location) {
  const content = document.createElement('div')
  const name = document.createElement('strong')
  name.textContent = location.name

  const count = document.createElement('span')
  count.textContent = `${location.count} response${location.count !== 1 ? 's' : ''}`

  content.append(name, document.createElement('br'), count)
  return content
}
